module.exports = __webpack_public_path__ + "img/AUD.6f6037c4.svg";